/* eslint-disable */
const contentful = require("contentful");
const _ = require("lodash");
const client = contentful.createClient({
	// This is the space ID. A space is like a project folder in Contentful terms
	space: "94ounxwxp3q6",
	// This is the access token for this space. Normally you get both ID and the token in the Contentful web app
	accessToken: "4cb5dc7f0779268e1eda08c889f6f8a8efa3927437e56e7370addf14989ea994"
});

const state = {
	loading: false,
	loaded: false,
	showSignup: false,
	response: {
		main: {},
		faq: [],
		schedule: [],
		testimonials: [],
		links: [],
		about: {}
	}
};

const getters = {
	mainPageItems(st) {
		return st.response.main;
	},

	showSignup(st) {
		return st.showSignup;
	},


	aboutItems(st) {
		return st.response.about;
	},
	faqItems(st) {
		return _.sortBy(st.response.faq, ['faqSort']);
	},
	testimonialItems(st) {
		return st.response.testimonials;
	},
	otherItems(st) {
		//return st.response.schedule;
		//days of week
		let schedule = [
		[[], [], [], [], [], [], []],
		[[], [], [], [], [], [], []]
		]
		let activities = {};
		st.response.schedule.map(item => {
			var dow = item.scheduleDayNumber - 1;
			//if (dow == 0) dow = 6;
			schedule[item.scheduleRoom][dow].push({
				time: item.scheduleTime,
				name: item.scheduleDescription,
				id: item.scheduleActivity.sys.id,
				type: item.scheduleActivity.fields.activityName,
				highlight: item.scheduleHighlight,
			});
			activities[item.scheduleActivity.sys.id] = Object.assign({id:item.scheduleActivity.sys.id},item.scheduleActivity.fields);
		})

		var activitiesArr = _.sortBy(Object.keys(activities).map(k=>activities[k]),  ['activityOrder']);

		schedule.map((room, k)=> {
			schedule[k].map((day,i) => {
				var o =_.sortBy(day, ['time']);
				console.log(o, day);
				schedule[k][i] = o;
			})
		})

		return { schedule: schedule, activities: activitiesArr };
	},

	linksItems(st) {
		var out = {}
		st.response.links.map(item => {
			var cat = item.linkCategory.toLowerCase();
			if (!out[cat]) out[cat] = [];
			out[cat].push(item);
		})
		return out;
	},

	loading(st) {
		return st.loading;
	},
	loaded(st) {
		return st.loaded;
	},

};

const actions = {
	async getMain({ commit }) {
		commit("loading");
		try {
			console.log(this);
			// const response = await client.getEntry('4cTbSrUcC4Igg8OGUA8w2o');
			const response = await client.getEntries();
			console.log(response);
			commit("process", response);
		} catch (e) {
			//commit("loaded", []);
			console.log('error loading res: ', e);
		}
	}
};

const mutations = {
	loading(st) {
		st.loading = true;
	},
	toggleSignup(st){
		st.showSignup =  !st.showSignup;
	},
	process(st, resp) {
		//st.response = resp;
		st.loading = false;
		st.loaded = true;

		resp.items.map((page) => {
			if (page.sys.contentType.sys.id == 'mainPage')
				st.response.main = page.fields;

			if (page.sys.contentType.sys.id == 'faq')
				st.response.faq.push(page.fields);

			if (page.sys.contentType.sys.id == 'schedule')
				st.response.schedule.push(page.fields);

			if (page.sys.contentType.sys.id == 'testimonial')
				st.response.testimonials.push(page.fields);

			if (page.sys.contentType.sys.id == 'link')
				st.response.links.push(page.fields);

			if (page.sys.contentType.sys.id == 'about')
				st.response.about = page.fields;

		})
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
